import { useSearch } from "@/hooks/useSearch"
import type { FC } from "react"
import { memo } from "react"
import { useHistory } from "react-router-dom"

import "./style.sass"
import { TabItem } from "./TabItem"

const SettingsTabsComponent: FC = () => {
  const { pathname } = useSearch()
  const history = useHistory()

  const isTwoFactor = pathname.startsWith("/settings/two-factor")

  return (
    <div className="settings-tabs">
      <TabItem isActive={isTwoFactor} onClick={() => (!isTwoFactor ? history.push("/settings/two-factor") : null)} title="2FA" />
    </div>
  )
}

export const SettingsTabs = memo(SettingsTabsComponent)
